import api from "./api";
import auth from "./auth";

const BASE_SERVICE_URL = "survey-service/v1/cms/survey";
const TARGET_SERVICE_URL = "target-segment-service/target-segment/module-options";

export default {
    getList(param) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/list/" + param.page,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    create(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/create",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    update(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/update",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getTargetSegments() {
        return new Promise((resolve, reject) => {
            api.get(
                TARGET_SERVICE_URL,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    delete(id) {
        return new Promise((resolve, reject) => {
            api.delete(
                BASE_SERVICE_URL + "/delete/" + id,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    view(param) {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL +
                "/customers/" +
                param.survey_id + "/" +
                param.target_segment_uuid +
                "/" + param.page,
            auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    export(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL +
                "/customers/export",
                param,
            auth.getHeader())
            .then(response => {
                return resolve(response);
            })
            .catch((status, error) => {
                reject(status, error);
            })
        });
    }
}
